import i18n from "../../i18next/i18next";

export const billingType = [{
    value: "constant",
    name: i18n.t("global:servicevaluation.constant"),
}, {
    value: "rateOneKm",
    name: i18n.t("global:servicevaluation.rateOneKm"),
}
];


export const getTypeOfSettlementTransportService = () => [
    {
        value: "auto",
        name: i18n.t("global:servicevaluation.auto"),
    },
    {
        value: "counter",
        name: i18n.t("global:servicevaluation.rateOneKm"),
    },
    {
        value: "manual",
        name: i18n.t("global:servicevaluation.manual"),
    },
    {
        value: "constant",
        name: i18n.t("global:servicevaluation.constant"),
    },
];